angular.module('blc').directive('searchForm', search_form_dir);
search_form_dir.$inject = ['quote', '$timeout', '$rootScope', '$sce'];
function search_form_dir(quote, $timeout, $rootScope, $sce) {
  var error = null;
  if (isMobile()) {
    $('body').on('focus', '.search-form .dates [type=button]', function() { this.click(); });

    var listener = function () {
      $('body').trigger('click');
      $('.dates input').trigger('blur');
    }
    window.addEventListener('popstate', listener, false);
  }
  return {
    replace: true,
    scope: true,
    restrict: 'A',
    templateUrl: '/search-form-template.html',
    link: link,
    controller: ['$scope','$element', controller],
  }
  function link(scope, element, params) {
  }
  function controller($scope, $element) {
   // $scope.currtab     = quote.atype;
    $scope.quote       = quote;
    $scope.places      = quote.places;
    $scope.geo         = quote.geo;
    $scope.rentalhours = quote.hours();
    $scope.rentaldays  = quote.days();
    $scope.dates       = quote.dates;
    $scope.error       = error;
    $scope.$watch('[rentaldays,rentalhours]', watch_hours);
    $scope.$watch('currtab', reset_hours_days);
    $rootScope.$on('generic quote error', show_generic_error);
    var that = $scope;
    that.current_date = null;
    $('body').on('click', function (event) {
      if ($(event.target).closest('.dates').length > 0) return;
      that.$apply(function($scope) { $scope.current_date = null; });
    })

    that.goto_search = function() {
      if (quote.ready()) {
        quote.goto_search();
      } else {
        show_generic_error();
      }
    }
    that.$on('error', error_watcher);
    // that.$watch('dates', dates_watcher, 1);
    that.$watch('current_date', function (curr, prev) {
      if(isMobile()){
        if (prev == curr) return; // init
        if (prev == null && curr !== null) {
          // add to history
          if (typeof history.pushState != 'undefined') {
            $(window).scrollTop($('.dates').offset().top - 20);
            history.pushState({popup: '.dates'}, null, null);
          }

          window.setTimeout(function(){
            var lendar_of_selected = $(picker.el).find('.range-start').closest('.pika-lendar');
            lendar_of_selected.length > 0 ? $(window).scrollTop(lendar_of_selected.offset().top - 37 ) : $(window).scrollTop($(picker.el).offset().top - 37);
          },0)
          $('.dates input').on('blur', function () {     //need to disable jumping after change to back state
            $(window).scrollTop($('.dates').offset().top - 20);
          })
        }
      }
      if (curr === 0) {
        picker.setMinDate(new Date());
        picker.draw();
        isMobile()? $('.img_wrap img').css('transition','none'):0;
      } else if (curr === 1) {
        picker.setMinDate(that.dates[0]);
        picker.draw();
        isMobile()? $('.img_wrap img').css('transition','none'):0;
      } else {
        $('.img_wrap img').css('transition','opacity 1s');
      }

    });
    function watch_hours(curr,prev) {
      var d = moment($scope.dates[0]);
      switch (quote.atype) {
        case 2:
          d.add(curr[0],'days');
          break;
        case 1:
          d.add(curr[1],'hours');
          break;
      }

      $scope.quote.dates[1] = d.toDate();
    }
    function reset_hours_days(curr, prev) {
      switch (curr) {
        case '0':
          $scope.dates[1] = null;
          break;
        default:
          $scope.places[1] = null;
          watch_hours([ $scope.rentaldays, $scope.rentalhours ])
      }
    }

    function dates_watcher(curr, prev) {
      if (curr === prev) return; // init

      if (that.current_date==0) { // start date selected
        picker.setMinDate(curr[0]);
        picker.setRangeStart(curr[0]);
        if (curr[1] && curr[1]<curr[0]) {
          curr[1] = new Date(curr[0]);
          curr[1].setDate(curr[1].getDate() + 3);
        }
        that.current_date = null; //isMobile() ? null : 1;
      } else if (that.current_date==1) { // end date selected
        picker.setRangeEnd(curr[1]);
        that.current_date = null;
      }
      picker.draw();
    }
    function error_watcher(evt, elm) {
      if (elm===null) {
        that.error_message = null;
        return;
      }
      if (elm.attr('googleplace') ) {
        that.error_message = $sce.trustAsHtml("We Are Always Expanding.<br>Unfortunately, <b>we don't service <u>" + elm.val() + "</u></b> at the moment.<br>Please search within Europe or UAE.");
        elm.after($element.find('.search_error'));
        ga('send','event','search','error location',elm.val());
      }
      if (elm=='general') {
        that.error_message = "We Need Your Exact Pickup Location<br>We deliver your car wherever you want it.<br>Please choose an exact location from our search options.";
        $element.find('[googleplace]:first').after($element.find('.search_error'));
      }
    }
    function show_generic_error() {
      that.error_message = $sce.trustAsHtml("We Need Your Exact Pickup Location<br>We deliver your car wherever you want it.<br>Please choose an exact location from our search options.");
      var elm = $element.find('[googleplace]:first');
      elm.after($element.find('.search_error'));
    }
  }
}



/*****************
 ** WEBPACK FOOTER
 ** ./gulp/assets/javascripts/search-form-directive.js
 ** module id = 22
 ** module chunks = 0
 **/